import { Svg, Path } from '../_Svg';
import type { IconComponent } from '..';
import useIconProps from '../useIconProps';
import { assignWithoutSideEffects } from '~utils/assignWithoutSideEffects';

const _CurrentAccountIcon: IconComponent = ({ size, color, ...styledProps }) => {
  const { height, width, iconColor } = useIconProps({ size, color });

  return (
    <Svg {...styledProps} width={width} height={height} viewBox="0 0 24 24" fill="none">
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.0122 2.53569C11.5777 2.04084 12.4221 2.04084 12.9877 2.53568L19.657 8.3713C20.6993 9.28336 20.0542 11.0002 18.6692 11.0002H5.33065C3.94561 11.0002 3.30053 9.28337 4.34289 8.3713L11.0122 2.53569ZM11.9999 4.32893L6.66137 9.00017H17.3385L11.9999 4.32893ZM7.99992 12.0002C8.55221 12.0002 8.99992 12.4479 8.99992 13.0002V17.0002C8.99992 17.5525 8.55221 18.0002 7.99992 18.0002C7.44764 18.0002 6.99992 17.5525 6.99992 17.0002V13.0002C6.99992 12.4479 7.44764 12.0002 7.99992 12.0002ZM11.9999 12.0002C12.5522 12.0002 12.9999 12.4479 12.9999 13.0002V17.0002C12.9999 17.5525 12.5522 18.0002 11.9999 18.0002C11.4476 18.0002 10.9999 17.5525 10.9999 17.0002V13.0002C10.9999 12.4479 11.4476 12.0002 11.9999 12.0002ZM15.9999 12.0002C16.5522 12.0002 16.9999 12.4479 16.9999 13.0002V17.0002C16.9999 17.5525 16.5522 18.0002 15.9999 18.0002C15.4476 18.0002 14.9999 17.5525 14.9999 17.0002V13.0002C14.9999 12.4479 15.4476 12.0002 15.9999 12.0002ZM19.9999 20.0002C19.9999 20.5525 19.5522 21.0002 18.9999 21.0002L4.99992 21.0002C4.44764 21.0002 3.99992 20.5525 3.99992 20.0002C3.99992 19.4479 4.44764 19.0002 4.99992 19.0002L18.9999 19.0002C19.5522 19.0002 19.9999 19.4479 19.9999 20.0002Z"
        fill={iconColor}
      />
    </Svg>
  );
};

const CurrentAccountIcon = assignWithoutSideEffects(_CurrentAccountIcon, {
  componentId: 'CurrentAccountIcon',
});

export default CurrentAccountIcon;
